<div *ngIf="itDeviceService.active && !tabsService.minimizeScreenMode">

  <form #form="ngForm" [ngClass]="['active',  tabsService.fullScreenMode ? 'fullscreen' : '']"
        autocomplete="off" >

    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>RFI-Transmitter Information</h4><span> </span>
        </div>

        <div class="input-fields">
          <div>
            <label for="name">Name</label>
            <input id="name" type="text" required minlength="0" maxlength="30"
                   [(ngModel)]="itDeviceService.selectedDevice.name" name="name"/>
          </div>
        </div>

        <div class="dropdown-fields" >
          <div>
            <label for="originator">Originator</label>
            <select id="originator" required [disabled]="itDeviceService.selectedDevice.id > 0"
                    [(ngModel)]="itDeviceService.selectedDevice.groupOriginator" name="originator">
              <ng-container
                *ngIf="gritUserService.groupsPaths.includes(itDeviceService.selectedDevice.groupOriginator) ||
                itDeviceService.selectedDevice.groupOriginator == ''; else otherOriginator">

                <ng-container *ngFor="let group of gritUserService.getRoleGroupsPaths(GritUserRoleGroup.FullUser)">
                  <option [value]="group">{{group}}</option>
                </ng-container>
              </ng-container>
              <ng-template #otherOriginator>
                <option [value]="itDeviceService.selectedDevice.groupOriginator">
                  {{ itDeviceService.selectedDevice.groupOriginator }}</option>
              </ng-template>
            </select>
          </div>

          <div *ngIf="itDeviceService.selectedDevice.id == 0">
            <label for="device">Base RFI-Transmitter</label>
            <select id="device" #device required name="device"
                    [value]="itDeviceService.selectedDevice.device?.id ?? ''"
                    (change)="changeDevice($event.target.value)"
            [ngClass]="device.value == '' ? 'ng-invalid' : ''">
              <option value="" selected>Select one...</option>
              <option *ngFor="let item of deviceService.devices"
                      [value]="item.id">{{item.name}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="fields__block__section">
        <div class="title">
          <h4>Position</h4><span> </span>
        </div>

        <div class="input-fields">
          <div>
            <label>Latitude</label>
            <div class="coordenates">
              <div>
                <select id="latitude-cardinal" name="lat-cardinal" required
                        [(ngModel)]="itDeviceService.selectedDevice.latitude.cardinal"
                        style="width: auto;">
                  <option value="N">N</option>
                  <option value="S">S</option>
                </select>

                <input id="latitude-degrees" type="number" name="lat-degrees" required
                       [(ngModel)]="itDeviceService.selectedDevice.latitude.degrees"
                       style="width: 16%;"><span>º</span>
                <input id="latitude-minutes" type="number" name="~lat-minutes" required
                       [(ngModel)]="itDeviceService.selectedDevice.latitude.minutes"
                       style="width: 16%;"><span>´</span>
                <input id="latitude-seconds" type="number" name="lat-seconds" required
                       [(ngModel)]="itDeviceService.selectedDevice.latitude.seconds"
                       style="width: 16%;"><span>´´</span>
              </div>

              <br />

              <input id="latitude-value" type="number" name="lat-value" required
                     [(ngModel)]="itDeviceService.selectedDevice.latitude.value"
                     style="width: 65.5%; margin-top: 5px; margin-bottom: 5px;">
              <span>º</span>
              <span class="error" *ngIf="!itDeviceService.selectedDevice.latitude.valid('value')">
              The Latitude value must be an integer number defined between -90º and 90º.
            </span>
              <span class="error" *ngIf="!itDeviceService.selectedDevice.latitude.valid('degrees')">
              The Degrees value must be an integer number defined between 0º and 90º.
            </span>
              <span class="error" *ngIf="!itDeviceService.selectedDevice.latitude.valid('minutes')">
              The Minutes value must be an integer number defined between 0 and 59 minutes.
            </span>
              <span class="error" *ngIf="!itDeviceService.selectedDevice.latitude.valid('seconds')">
              The Seconds value must be defined between 0 and 59.99.
            </span>
            </div>
          </div>

          <div>
            <label>Longitude</label>
            <div class="coordenates">
              <div>
                <select id="longitude-cardinal" name="lon-cardinal" required
                        [(ngModel)]="itDeviceService.selectedDevice.longitude.cardinal"
                        style="width: auto;">
                  <option value="E">E</option>
                  <option value="W">W</option>
                </select>

                <input id="longitude-degrees" type="number" name="lon-degrees" required
                       [(ngModel)]="itDeviceService.selectedDevice.longitude.degrees"
                       style="width: 16%;"><span>º</span>
                <input id="longitude-minutes" type="number" name="lon-minutes" required
                       [(ngModel)]="itDeviceService.selectedDevice.longitude.minutes"
                       style="width: 16%;"><span>´</span>
                <input id="longitude-seconds" type="number" name="lon-seconds" required
                       [(ngModel)]="itDeviceService.selectedDevice.longitude.seconds"
                       style="width: 16%;"><span>´´</span>
              </div>
              <br/>
              <input id="longitude-value" type="number" name="lon-value" required
                     [(ngModel)]="itDeviceService.selectedDevice.longitude.value"
                     style="width: 65.5%; margin-top: 5px; margin-bottom: 5px;">
              <span>º</span>
              <span class="error" *ngIf="!itDeviceService.selectedDevice.longitude.valid('value')">
              The Longitude value must be an integer number defined between -180º and 180º.
            </span>
              <span class="error" *ngIf="!itDeviceService.selectedDevice.longitude.valid('degrees')">
              The Degrees value must be an integer number defined between 0º and 180º.
            </span>
              <span class="error" *ngIf="!itDeviceService.selectedDevice.longitude.valid('minutes')">
              The Minutes value must be an integer number defined between 0 and 59 minutes.
            </span>
              <span class="error" *ngIf="!itDeviceService.selectedDevice.longitude.valid('seconds')">
              The Seconds value must be defined between 0 and 59.99.
            </span>
            </div>
          </div>

          <div>
            <label for="direction">Direction</label>
            <input id="direction" type="number" name="direction" required
                   [(ngModel)]="itDeviceService.selectedDevice.direction"/><span>[º]</span>
          </div>
        </div>
      </div>

      <div class="fields__block__section">
        <div class="title">
          <h4>Visibility</h4><span> </span>
        </div>

        <div class="input-fields">
          <div>
            <label for="mask-radius">Mask Radius</label>
            <input id="mask-radius" type="number" required min="0" name="mask-radius"
                   [(ngModel)]="itDeviceService.selectedDevice.maskRadius"
                   (ngModelChange)="updateMaskArea()"
            /><span>[Km]</span>
          </div>
        </div>
      </div>
    </div>

    <fieldset class="fields__block" disabled style="max-height: 100%; overflow: scroll"
              *ngIf="itDeviceService.selectedDevice.device != null">

      <div class="fields__container__tabs">
        <div class="fields__container__tabs__item" (click)="activateTab(0)">
          <a class="tab-button" [ngClass]="this.tabActive[0] ? 'active' : ''" href="#">Information</a>
        </div>
        <div class="fields__container__tabs__item" (click)="activateTab(1)">
          <a [ngClass]="this.tabActive[1] ? 'active' : ''" href="#">Sectorization</a>
        </div>
      </div>

      <ng-container *ngIf="tabActive[0]">
        <div class="fields__block__section">

          <div class="title">
            <h4>Base RFI-Transmitter Information</h4><span> </span>
          </div>

          <div class="input-fields">
            <div>
              <label for="nameDevice">Name</label>
              <input id="nameDevice" type="text"
                     [value]="itDeviceService.selectedDevice.device.name" name="nameDevice"/>
            </div>
          </div>

          <div class="dropdown-fields">
            <div>
              <label for="mainType">Type</label>
              <select id="mainType"
                      [(ngModel)]="itDeviceService.selectedDevice.device.mainType" name="mainType">
                <option *ngFor="let item of DeviceModel.fieldsValues.maintype"
                        [value]="item.value">{{item.display}}</option>
              </select>
            </div>

            <div>
              <label for="subType">Sub-Type</label>
              <select id="subType"
                      [value]="itDeviceService.selectedDevice.device.subType" name="subType">
                <ng-container *ngFor="let item of DeviceModel.fieldsValues.type">
                  <option *ngIf="item.value.startsWith(itDeviceService.selectedDevice.device.mainType)"
                          [value]="item.value.split('/').at(1)">
                    {{item.display.split("/").at(1)}}</option>
                </ng-container>
              </select>
            </div>
          </div>

          <div class="input-fields">
            <div>
              <label for="deviceTs">Clone Timestamp</label>
              <input id="deviceTs" type="datetime-local" disabled
                     [value]="itDeviceService.selectedDevice.tsCreate">
            </div>
          </div>
        </div>

        <div class="fields__block__section">
          <div class="title">
            <h4>Technical Specifications</h4><span> </span>
          </div>

          <div class="input-fields">
            <div>
              <label>Antenna Polarisation</label>
              <select id="antennaPolarisation" name="antennaPolarisation" required
                      [(ngModel)]="itDeviceService.selectedDevice.device.antennaPolarisation">
                <option value="linear">Linear</option>
                <option value="RHCP">RHCP</option>
              </select>
            </div>

            <div>
              <label>Power</label>
              <div class="coordenates">
                <div>
                  <input id="power_dBW" type="number" name="power_dBW" [disabled]="itDeviceService.selectedDevice.device.userDefined != 'power'"
                         [(ngModel)]="itDeviceService.selectedDevice.device.power.dBW"
                         style="width: 30%;"
                  /><span>[dBW]</span>
                  <input id="power_dBm" type="number" name="power_dBm" [disabled]="itDeviceService.selectedDevice.device.userDefined != 'power'"
                         [(ngModel)]="itDeviceService.selectedDevice.device.power.dBm"
                         style="width: 30%;"
                  /><span>[dBm]</span>
                </div>
              </div>
            </div>

            <div>
              <label for="range">Maximum Potential Range</label>
              <input id="range" type="number" name="range" [disabled]="itDeviceService.selectedDevice.device.userDefined != 'range'"
                     [(ngModel)]="itDeviceService.selectedDevice.device.range"

              /><span>[NM]</span>
            </div>

            <div>
              <label for="frequency">Frequency</label>
              <input id="frequency" type="number" name="frequency" required
                     [(ngModel)]="itDeviceService.selectedDevice.device.frequency"

              /><span>[GHz]</span>
            </div>

            <div>
              <label for="antennagain">Vertical Gain</label>
              <input id="antennagain" type="number" name="antennagain" required
                     [(ngModel)]="itDeviceService.selectedDevice.device.verticalGain"

              /><span>[dBi]</span>
            </div>
          </div>
        </div>

      </ng-container>
      <ng-container *ngIf="tabActive[1]">
        <div class="fields__block__section">
          <div class="table-fields">
            <div>
              <div>
                <table>
                  <thead>
                  <tr>
                    <th>Type</th>
                    <th>Power [dBW]</th>
                    <th>Gain [dBi]</th>
                    <th>Min Azimuth [deg]</th>
                    <th>Max Azimuth [deg]</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    mdbTableCol
                    *ngFor="let el of itDeviceService.selectedDevice.device.sectorizations; index as i"
                    (click)="el.selected = !el.selected"
                    [class.deleted]="el.deleted && !el.selected"
                    [class.highlighted]="el.selected"
                  >
                    <td>{{ el.type }}</td>
                    <td>{{ el.power.dBW }}</td>
                    <td>{{ el.gain }}</td>
                    <td>{{ el.minAngle }}</td>
                    <td>{{ el.maxAngle }}</td>
                  </tr>
                  </tbody>
                </table>
                <!--              <div class="btn">-->
                <!--                <a (click)="addSectorizationTrigger()">Add Sector</a>-->
                <!--                <a (click)="deleteSectorizations()">Delete Sector</a>-->
                <!--                <a (click)="displaySectorizations()">Sectorization Display</a>-->
                <!--              </div>-->
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </fieldset>

    <div class="fields__btn">
      <button type="submit" (click)="submit(itDeviceService.selectedDevice.id == 0)"
              [disabled]="!form.form.valid || itDeviceService.selectedDevice.device == null"
              [ngClass]="form.form.valid && itDeviceService.selectedDevice.device != null ? 'blue' : 'gray'" >Save</button>
      <button (click)="tabsService.closeTab()" class="gray" href="#" type="reset" value="Cancel">Cancel</button>
    </div>
  </form>
</div>
